<div #previewPortal>
  @if (isOpen() && document()) {
  <!-- Backdrop -->
  <button
    type="button"
    class="fixed inset-0 bg-black/90 cursor-default"
    style="z-index: 1000"
    aria-label="Close preview"
    (click)="onClose()"
  ></button>

  <div
    class="fixed inset-0 flex flex-col items-center justify-center pointer-events-none"
    style="z-index: 1001"
  >
    <!-- Header bar -->
    <div
      class="absolute top-0 left-0 right-0 flex items-center justify-between px-4 sm:px-6 py-3 bg-gradient-to-b from-black/60 to-transparent pointer-events-auto"
    >
      <div class="flex items-center gap-3 min-w-0">
        <span class="material-symbols-outlined !text-[20px] text-white/80"
          >{{ isPdf() ? 'picture_as_pdf' : 'image' }}</span
        >
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-medium text-white truncate"
            >{{ document()!.name }}</span
          >
          <div class="flex items-center gap-2 mt-0.5">
            @if (categoryLabel()) {
            <span
              class="inline-flex px-2 py-0.5 rounded-full text-[10px] font-medium bg-white/15 text-white/80"
              >{{ categoryLabel() }}</span
            >
            } @if (document()!.fileSize) {
            <span class="text-[11px] text-white/60"
              >{{ formatFileSize(document()!.fileSize) }}</span
            >
            }
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2 shrink-0">
        <a
          [href]="document()!.storageUrl"
          target="_blank"
          rel="noopener"
          class="p-2 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
        >
          <span class="material-symbols-outlined text-white !text-xl"
            >download</span
          >
        </a>
        <button
          type="button"
          class="p-2 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
          (click)="onClose()"
        >
          <span class="material-symbols-outlined text-white !text-xl"
            >close</span
          >
        </button>
      </div>
    </div>

    <!-- Content -->
    @if (isPdf() && safeUrl()) {
    <iframe
      [src]="safeUrl()!"
      class="w-full sm:w-[90vw] sm:max-w-4xl h-[85vh] rounded-lg pointer-events-auto mt-14 bg-white"
      [title]="document()!.name"
    ></iframe>
    } @else {
    <img
      [src]="document()!.storageUrl"
      [alt]="document()!.name"
      class="max-w-full max-h-[85vh] object-contain pointer-events-auto mt-14"
      referrerpolicy="no-referrer"
    />
    }
  </div>
  }
</div>
